import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  useIntl,
  Link,
} from "gatsby-plugin-react-intl";

const SearchResult = ({props}) => {
  const intl = useIntl();

  const tempData = useStaticQuery(graphql`
    query SearchData {
      cSearchText : allContentfulSearchText(
        sort: {fields: createdAt, order: DESC}
      ) {
        edges {
          node {
            node_locale
            title
            slug
            content {
              childMarkdownRemark {
                excerpt(format: PLAIN, pruneLength: 99999)
              }
            }
          }
        }
      }
      cMediaRoomNews : allContentfulMediaRoomNews(
        filter: {
          slug: { ne: "do-not-delete-sample" }
        }
      ){
        edges {
          node {
            node_locale
            title
            category
            slug
            content {
              raw
            }
          }
        }
      }
    }
  `)

  const allPostsOthers = tempData.cSearchText.edges
  const allPostsMedia = tempData.cMediaRoomNews.edges
  const allPosts = [...allPostsOthers, ...allPostsMedia];

  const allPostsFiltered = allPosts.filter(post => {
    const title = post.node.title
    return (
      title.toLowerCase().includes("XXXXAAAASSSS")
    )
  })
  const emptyQuery = ""
  const [state, setState] = useState({
    filteredData: [],
    query: emptyQuery,
  })

  const handleInputChange = event => {
    const query = event.target.value
    //const posts = tempData.cSearchText.edges || []
    const posts = allPosts || []

    const filteredData = posts.filter(post => {
      const locale = post.node.node_locale
      const title = post.node.title
      const content = post.node.content.childMarkdownRemark ? post.node.content.childMarkdownRemark.excerpt : post.node.content.raw
      return (
        locale.toLowerCase().includes(intl.locale) &&
        (
          title.toLowerCase().includes(query.toLowerCase()) ||
          content.toLowerCase().includes(query.toLowerCase())
        )
      )
    })
    setState({
      query,
      filteredData,
    })
  }
  const { filteredData, query } = state
  const hasSearchResults = filteredData && query !== emptyQuery
  const result = hasSearchResults ? filteredData : allPostsFiltered

  return (

    <div className="menu menu-search">
      <div className="menu_inner">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 23 23"
          className="searchIconSearch"
        >
          <g fill="none" fill-rule="evenodd">
            <g stroke="#fff" stroke-width="2">
              <g transform="translate(-1502.000000, -39.000000) translate(1503.000000, 40.000000)">
                <circle cx="8.029" cy="8.029" r="8.029" />
                <path
                  stroke-linecap="square"
                  d="M14.206 14.206L19.799 19.799"
                />
              </g>
            </g>
          </g>
        </svg>
        <input
          type="text"
          className="base_underline"
          placeholder="Searchterm"
          ariaLabel="Search"
          onChange={handleInputChange}
        />
      </div>

      <div className="result_inner">
        <div className="result_inner__search">
          <div className="result_inner__res">
            {/*query !== "" ?
              query + " の検索結果: " + result.length + "件"
              : result.length + "件の記事"
            */}
            {state.query.length > 0 && <span>HIT: {result.length}</span>}
          </div>
          {/*JSON.stringify(result)*/}
          {/*JSON.stringify(allPosts)*/}
          {result && result.map(({ node: post }) => {
            return (
              <div>
              <Link to={post.category ? "/news/" + post.slug : post.slug}>
                <p className="slug">{post.category ? "/news/" + post.slug : post.slug}</p>
                <p className="title">{post.title}</p>
              </Link>
              </div>
            )
          })}
        </div>
      </div>

    </div>
  )
}

export default SearchResult